import { render, staticRenderFns } from "./ModalComoFunciona.vue?vue&type=template&id=528c395a&scoped=true&lang=pug&"
import script from "./ModalComoFunciona.vue?vue&type=script&lang=js&"
export * from "./ModalComoFunciona.vue?vue&type=script&lang=js&"
import style0 from "./ModalComoFunciona.vue?vue&type=style&index=0&id=528c395a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c395a",
  null
  
)

export default component.exports